import React from "react";
import { Redirect, useParams } from "react-router-dom";
import invariant from "tiny-invariant";
import { isMatching, P } from "ts-pattern";

import { fetchWithAuth } from "~/common/fetch";
import { remoteLog } from "~/common/logging";
import { redirectTo } from "~/common/navigation";
import { useRequiredUser } from "~/common/user";
import { Button } from "~/components/ui/button";
import { Layout } from "~/components/ui/layout";
import { Portlet, PortletTitle } from "~/components/ui/portlet";
import { useGetEventPaymentStatusQuery } from "~/features/events/events-api";

import { PaymentStatusMessage } from "./common/payment-status-message";

export default function ElitePage({ bareLayout }: { bareLayout?: boolean } = {}) {
  const user = useRequiredUser();

  if (!user.elite_to_be_paid) {
    return <Redirect to="/pages/patients" />;
  }

  const toBePaidFormatted = new Intl.NumberFormat("ru-RU", { currency: "RUB" }).format(
    user.elite_to_be_paid,
  );

  async function payElite() {
    try {
      const API_ELITE = `${process.env.API}/elite`;
      const response = await fetchWithAuth(API_ELITE, { method: "POST" });
      const json = await response.json();
      invariant(isMatching({ link: P.string }, json), `${API_ELITE} - unexpected json received`);
      const link = json.link;
      redirectTo(link);
    } catch (err) {
      remoteLog(err, "payElite");
    }
  }

  return (
    <Layout chrome={!bareLayout}>
      <Portlet as="main">
        <PortletTitle iconClassName="icon-book-open">Оплата членства в 3D Smile Elite</PortletTitle>

        <div className="portlet-body tw-space-y-4 max-desktop:tw-text-center">
          <Button rounded onClick={payElite}>
            Оплатить {toBePaidFormatted} руб.
          </Button>
        </div>
      </Portlet>
    </Layout>
  );
}

export function ElitePaymentStatus({ bareLayout }: { bareLayout?: boolean } = {}) {
  const { transaction_id } = useParams<{ transaction_id: string }>();

  const invoiceQuery = useGetEventPaymentStatusQuery({ transactionId: transaction_id });

  return (
    <Layout chrome={!bareLayout}>
      <Portlet as="main" className="tw-h-full">
        <PortletTitle iconClassName="icon-book-open">Оплата членства в 3D Smile Elite</PortletTitle>

        <div className="portlet-body tw-space-y-4 max-desktop:tw-text-center">
          <PaymentStatusMessage query={invoiceQuery} />
        </div>
      </Portlet>
    </Layout>
  );
}
